"use client"
import React, { useState, useEffect } from "react";
import useFetch from '@/app/useFetch'
import Link from 'next/link';
import { IMG_URL } from '@/app/config';
import { formatDateShort } from '@/app/helpers';
import { useTheme } from '@/app/theme-provider';
import Loader from "./Loader";
import Pegination from "./Pegination";
const CourtsandTribumalwings = () => {
    const { language } = useTheme()
        const [currentPage, setCurrentPage] = useState(1);
        const [limit, setLimit] = useState(10);
    
        const [searchTerm, setSearchTerm] = useState("");
        const [debouncedSearch, setDebouncedSearch] = useState("");
    const { data: list, loading, error } = useFetch(
        "/website/wings-courts-and-tribunals",
        []
    );

 useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(searchTerm);
            setCurrentPage(1); // reset to page 1 when searching
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const { data: listcourts = [], totalPages, loadingc, errorc } = useFetch(
        "/website/wings-courts-and-tribunals",
        {
            page: currentPage,
            limit: limit,
            search: debouncedSearch,
        },
        [debouncedSearch, currentPage, limit]
    );

    const handlePageChange = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <>
            <div className='row'>
                <div className='col'>
                    <div className='directorate-main'>
                        <h4>{language == "en" ? "SPECIAL COURTS" : "പ്രത്യേക കോടതികൾ"}</h4>
                        <p>{language == "en" ? "There are Six Special Courts functioning in the State exclusively for the trial of Vigilance Cases charge sheeted by this Bureau with Headquarters at Thiruvananthapuram, Kottayam, Muvattupuzha, Thrissur, Kozhikkode and Thalassery. Scope for filing appeal is examined in every case, which ends in acquittal and action is taken to file appeal if found necessary." : "തിരുവനന്തപുരം, കോട്ടയം, മൂവാറ്റുപുഴ, തൃശൂർ, കോഴിക്കോട്, തലശ്ശേരി എന്നിവിടങ്ങളിൽ ആസ്ഥാനമായി പ്രവർത്തിക്കുന്ന വിജിലൻസ് ബ്യൂറോ കുറ്റപത്രം സമർപ്പിക്കുന്ന കേസുകളുടെ വിചാരണയ്ക്കായി മാത്രമായി സംസ്ഥാനത്ത് ആറ് പ്രത്യേക കോടതികൾ പ്രവർത്തിക്കുന്നുണ്ട്. ഓരോ കേസിലും അപ്പീൽ സമർപ്പിക്കുന്നതിനുള്ള സാധ്യത പരിശോധിക്കപ്പെടുന്നു, ഇത് കുറ്റവിമുക്തനാക്കുന്നതിൽ അവസാനിക്കുകയും ആവശ്യമെങ്കിൽ അപ്പീൽ സമർപ്പിക്കാൻ നടപടി സ്വീകരിക്കുകയും ചെയ്യുന്നു."}</p>
                        <h4>{language == "en" ? "VIGILANCE TRIBUNALS" : "വിജിലൻസ് ട്രൈബ്യൂണലുകൾ"}</h4>
                        <p>{language == "en" ? "There are two Vigilance Tribunals, one each at Thiruvananthapuram and Kozhikkode to conduct detailed enquiry in disciplinary proceedings warranting the award of major penalties referred by the Government on the recommendations of this Bureau or otherwise relating to Gazetted officers in respect of matters involving corruption. The Vigilance Tribunals after completing enquiry forward the reports directly to Government with their recommendations for final disposal by Government." : "ഈ ബ്യൂറോയുടെ ശുപാർശകളുടെ അടിസ്ഥാനത്തിൽ സർക്കാർ നിർദ്ദേശിക്കുന്ന പ്രധാന ശിക്ഷകൾ നൽകുന്നതിന് ആവശ്യമായ അച്ചടക്ക നടപടികളിൽ വിശദമായ അന്വേഷണം നടത്തുന്നതിന് തിരുവനന്തപുരത്തും കോഴിക്കോടും രണ്ട് വിജിലൻസ് ട്രൈബ്യൂണലുകൾ ഉണ്ട് അല്ലെങ്കിൽ അഴിമതി ഉൾപ്പെടുന്ന കാര്യങ്ങളിൽ ഗസറ്റഡ് ഓഫീസർമാരുമായി ബന്ധപ്പെട്ടിരിക്കുന്നു. വിജിലൻസ് ട്രൈബ്യൂണലുകൾ അന്വേഷണം പൂർത്തിയാക്കിയ ശേഷം റിപ്പോർട്ടുകൾ സർക്കാരിന് അന്തിമ തീർപ്പിനായി നേരിട്ട് സർക്കാരിലേക്ക് അയയ്ക്കുന്നു."}</p>
                        <p>{language == "en" ? "A Centralized Processing System of Petitions (CPSP) is functioning in the VACB Directorate under the command and control of the SP (Int.) who will be assisted by the IB Inspector." : "വിഎസിബി ഡയറക്ടറേറ്റിൽ, ഐബി ഇൻസ്പെക്ടർ എസ്പി (ഇന്റർനാഷണൽ) യുടെ നേതൃത്വത്തിൽ ഒരു കേന്ദ്രീകൃത പെറ്റീഷനിംഗ് സിസ്റ്റം (സിപിഎസ്പി) പ്രവർത്തിക്കുന്നു, അദ്ദേഹത്തെ ഐബി ഇൻസ്പെക്ടർ സഹായിക്കും."}</p>
                        <p>{language == "en" ? "Government vide Circular No. 5681/C3/98/Vig. dated 31.12.2001 reiterated that the directions contained in Rule 5(b) and (C) of Kerala Civil Services (Vigilance Tribunal) Rules should be followed scrupulously by all Department Officers and they shall forward all disciplinary cases relating to Gazetted Officers in respect of matters involving corruption on the part of such officers, to Government in the Vigilance Department for the purpose of ordering disciplinary enquiry by the Vigilance Tribunals." : "കേരള സിവിൽ സർവീസസ് (വിജിലൻസ് ട്രൈബ്യൂണൽ) ചട്ടങ്ങളിലെ ചട്ടം 5(ബി) യിലും (സി) യിലും അടങ്ങിയിരിക്കുന്ന നിർദ്ദേശങ്ങൾ എല്ലാ വകുപ്പ് ഉദ്യോഗസ്ഥരും കർശനമായി പാലിക്കണമെന്നും, ഗസറ്റഡ് ഓഫീസർമാരുടെ ഭാഗത്തുനിന്നുള്ള അഴിമതിയുമായി ബന്ധപ്പെട്ട എല്ലാ അച്ചടക്ക കേസുകളും വിജിലൻസ് ട്രൈബ്യൂണലുകളുടെ അച്ചടക്ക അന്വേഷണത്തിന് ഉത്തരവിടുന്നതിനായി വിജിലൻസ് വകുപ്പിലെ സർക്കാരിന് അയയ്ക്കണമെന്നും 2001 ഡിസംബർ 31-ലെ സർക്കുലർ നമ്പർ 5681/C3/98/വിജി ആവർത്തിച്ചു."}</p>
                    </div>

                </div>
            </div>
             <div className="row mb-3 justify-content-end mt-5">
                    <div className="search-box d-flex align-items-center">
                        <input
                            type="text"
                            placeholder={language === "en" ? "Search" : "തിരയുക..."}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
                <h4 style={{ textAlign: "center" }}>VIGILANCE COURT CASE MANAGEMENT SYSTEM</h4>
                {loadingc ? (
                    <>
                        <Loader n={24} f={0.3} />

                    </>
                ) : <>
                    <div className="table-responsive tenders-table">
                        <table className="table  table-bordered text-center align-middle ">
                            <thead className="thead-dark">
                                <tr>
                                    <th scope="col">
                                        {language === "en" ? "Sl No." : "ക്രമം നമ്പർ"}
                                    </th>

                                    <th scope="col">
                                        {language === "en" ? "Name Of Court" : "കോടതിയുടെ പേര്"}
                                    </th>

                                    <th scope="col">
                                        {language === "en" ? "Link" : "ലിങ്ക്"}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {listcourts?.length > 0 ? (
                                    <>
                                        {listcourts?.map((item, index) => (
                                            <>
                                                <tr key={index}>
                                                    <td>{(currentPage - 1) * limit + index + 1}</td>

                                                    <td>{item.name}</td>
                                                    <td>
                                                        <Link target='blank' href={`${item.link}`}>
                                                            <button className=" ">
                                                                Click here
                                                            </button>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            </>
                                        ))}

                                    </>
                                ) : <>
                                    <tr>
                                        <td colSpan={3}>
                                            No data found
                                        </td>
                                    </tr>
                                </>}
                            </tbody>
                        </table>
                    </div>

                </>}
                {totalPages > 1 && (
                    <Pegination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}
        </>
    )
}

export default CourtsandTribumalwings
